// extracted by mini-css-extract-plugin
module.exports = {"acceptBtn":"EmployerApplication_acceptBtn__2PsAY","rejectBtn":"EmployerApplication_rejectBtn__3ijdS"};